export default {

    props: ['value']

}
